import { render, staticRenderFns } from "./FormCompany.vue?vue&type=template&id=4327fae0"
import script from "./FormCompany.vue?vue&type=script&lang=js"
export * from "./FormCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports